// ⚠️ FICHIER GÉNÉRÉ — ne pas éditer ici. Source : shared/ui/ · régénérer avec `bash shared/sync.sh`
/**
 * L'ORDRE d'un pied d'actions, construit par le code et non par convention.
 *
 * Module PUR (testé par `npm test`). `PiedActions` n'a aucune liberté sur
 * l'ordre : il rend ce que renvoie `ordonnerActions`, et cette fonction place
 * toujours  [ secondaires… ] [ Annuler ] [ action principale ].
 *
 * La principale est TOUJOURS la dernière (l'extrémité de la ligne), « Annuler »
 * TOUJOURS juste avant elle. Les types interdisent de faire de la principale un
 * bouton à contour ou discret : une action « principale » qui ne se voit pas
 * n'en est pas une.
 */
import type { VarianteBouton } from './boutonStyles';

export type ActionAnnuler = { libelle?: string; onClick: () => void; disabled?: boolean; title?: string };
export type ActionPrincipale = {
  libelle: string;
  onClick?: () => void;
  /** `submit` pour un vrai <form> : Entrée soumet. */
  type?: 'button' | 'submit';
  chargement?: boolean;
  /** Libellé pendant le chargement (« Enregistrement… »). Défaut : « … ». */
  libelleChargement?: string;
  disabled?: boolean;
  /** `danger` UNIQUEMENT pour confirmer une suppression irréversible. */
  variante?: Extract<VarianteBouton, 'primaire' | 'danger'>;
  /** Infobulle — surtout la RAISON d'un bouton désactivé (« Aucune mesure saisie »). */
  title?: string;
};
export type ActionSecondaire = {
  libelle: string;
  onClick: () => void;
  disabled?: boolean;
  variante?: Extract<VarianteBouton, 'contour' | 'discret' | 'danger'>;
  title?: string;
};

export type EntreesPied = {
  annuler?: ActionAnnuler;
  principale?: ActionPrincipale;
  secondaires?: ActionSecondaire[];
};

export type ActionOrdonnee =
  | { role: 'secondaire'; libelle: string; variante: 'contour' | 'discret' | 'danger'; onClick: () => void; disabled?: boolean; title?: string }
  | { role: 'annuler'; libelle: string; variante: 'contour'; onClick: () => void; disabled?: boolean; title?: string }
  | {
      role: 'principale'; libelle: string; variante: 'primaire' | 'danger'; onClick?: () => void; type: 'button' | 'submit';
      chargement: boolean; libelleChargement?: string; disabled?: boolean; title?: string;
    };

export function ordonnerActions({ annuler, principale, secondaires = [] }: EntreesPied): ActionOrdonnee[] {
  const sortie: ActionOrdonnee[] = secondaires.map((s) => ({
    role: 'secondaire', libelle: s.libelle, variante: s.variante ?? 'contour', onClick: s.onClick, disabled: s.disabled, title: s.title,
  }));
  if (annuler) {
    sortie.push({ role: 'annuler', libelle: annuler.libelle ?? 'Annuler', variante: 'contour', onClick: annuler.onClick, disabled: annuler.disabled, title: annuler.title });
  }
  if (principale) {
    sortie.push({
      role: 'principale', libelle: principale.libelle, variante: principale.variante ?? 'primaire', onClick: principale.onClick,
      type: principale.type ?? 'button', chargement: principale.chargement ?? false,
      libelleChargement: principale.libelleChargement, disabled: principale.disabled, title: principale.title,
    });
  }
  return sortie;
}
